@if (isClickEventListened) {
  <button
    [style.--color-state]="computedColor()"
    (click)="handleClick()"
    [class.kpi--active]="selected()"
    class="kpi kpi--clickable">
    <ng-container *ngTemplateOutlet="kpi"></ng-container>
  </button>
} @else {
  <div [style.--color-state]="computedColor()" (click)="handleClick()" class="kpi">
    <ng-container *ngTemplateOutlet="kpi"></ng-container>
  </div>
}

<ng-template #kpi>
  <div class="kpi_values">
    @if (value() !== null) {
      <p class="number">{{ value() }}</p>
    }
    @if (percentage !== null) {
      <p class="percentage">{{ roundedPercentage() }}%</p>
    }
  </div>
  <div class="kpi_progress" [style.--percentage.%]="percentage()"></div>
  <p class="kpi_label">{{ label() }}</p>
</ng-template>
